export default __webpack_public_path__ + "static/media/googleplay.01112669.svg";